<template>
  <button
    type="button"
    data-slot="refresh-button"
    :class="[
      'inline-flex items-center gap-1 text-xs font-medium underline-offset-4 hover:underline disabled:cursor-not-allowed disabled:opacity-50',
      inverted ? 'text-white' : 'text-primary',
    ]"
    :disabled="disabled || isLoading"
    @click="() => onClick()"
  >
    <refresh-cw-icon :class="[ 'size-3.5 shrink-0', isLoading && 'animate-spin' ]" />
    {{ label }}
  </button>
</template>

<script>
import { RefreshCw } from '@lucide/vue';

/**
 * Small link-style "update/refresh" action: runs `promise`, then toasts
 * `successMessage`.
 */
export default {
  name: 'RefreshButton',
  components: {
    RefreshCwIcon: RefreshCw,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      required: true,
    },
    promise: {
      type: Function,
      required: true,
    },
    // White text, for colored boxes (info texts, status messages).
    inverted: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    onClick() {
      if (this.isLoading || this.disabled) {
        return;
      }

      this.isLoading = true;

      const promise = this.promise();
      if (!promise) {
        return;
      }

      promise
        .then(resp => {
          this.$toast.clear();
          this.$toast.success(this.successMessage);
          return resp;
        })
        .catch(err => this.error(err))
        .finally(() => this.isLoading = false);
    },
  },
};
</script>
